// Where the MediaPipe wasm runtime is served from (vite.config.ts
// mediapipeWasm: same origin, at a path versioned with the installed JS).

export function wasmBase(): string {
  return __MEDIAPIPE_WASM_BASE__.replace(/\/+$/, "")
}
